import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Returns:
 *  { plan, usage, refresh }
 *  plan = { tier: "free"|"advanced", in_trial, trial_ends_at, advanced_until, source }
 *  usage = { photos_today, photos_daily_limit, price_usd, advanced_days_per_purchase, trial_days }
 */
export function usePlanUsage() {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/plans/usage");
      setUsage(data);
      return data;
    } catch {
      setUsage(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  return { usage, loading, refresh, plan: usage?.plan };
}

export const daysUntil = (iso) => {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};

export const formatDate = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};
